export const parentTypes = ['job', 'transaction', 'project', 'fpc-job'] as const;
